import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgAutomobileRace(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 -4 24 24" {...props}>
      <path
        d="M14.28 0L24 4.93l-2.813 6.722-7.915-4.015-.184.439 2.936 7.013-1.797.911L12 10.677 9.773 16l-1.797-.91 2.933-7.015-.182-.438-7.914 4.014L0 4.93 9.72 0 12 5.45zm1.824 1.848l-.672 1.61-1.452-.737-.83 1.982 1.453.737-.675 1.61 1.807.915.662-1.584-1.805-.916.832-1.989 1.808.916-.823 1.964 1.808.917-.674 1.608 1.806.916.664-1.582-1.806-.916.832-1.99 1.808.916-.822 1.964 1.46.74.83-1.982-1.46-.74.672-1.608-1.808-.918-.672 1.61-1.807-.916.67-1.611zM3.987 8.215l-.834-1.99 1.808-.916.822 1.964 1.808-.917.673 1.61 1.807-.917-.663-1.585-1.807.917-.833-1.989 1.808-.916.821 1.964 1.451-.737-.83-1.982-1.45.736-.673-1.609-1.807.916.673 1.61-1.808.917-.673-1.61-1.808.918.673 1.609-1.461.739.83 1.982 1.46-.74.675 1.608 1.807-.916-.663-1.584z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('AutomobileRace')(SvgAutomobileRace);
